import { Icon } from "@fluentui/react";
import * as React from "react";
import { parsePriceAsString, removeVat, roundToTwoDecimals } from "../../utils/vatConverter";
import "../style.css";

interface Props {
    discountPrice: number;
    amount: number;
    subItems: SubItem[] | undefined;
}

const DebitorPrice: React.FunctionComponent<Props> = ({ discountPrice, amount, subItems }) => {
    let price = discountPrice * amount;
    let calibration = null;
    if (subItems) {
        if (subItems.find(x => x.type === 3)) {
            calibration = (
                <span className="calibration__icon">
                    <Icon iconName="LocationDot"></Icon>
                </span>
            );
        }
    }
    return (
        <>
            <div>
                <p className="debitor_price__field">
                    {parsePriceAsString(roundToTwoDecimals(price))}
                </p>
            </div>
            <div>
                <p className="debitor_price__field">
                    {parsePriceAsString(roundToTwoDecimals(removeVat(price)))}
                </p>
            </div>
        </>
    );
};

export default DebitorPrice;